export default '1.11.2';



// WEBPACK FOOTER //
// ./~/instantsearch.js/src/lib/version.js